import { Droppable } from '@hello-pangea/dnd';
import { IoChevronDown } from 'react-icons/io5';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { useSectionsContext } from '../../../../context/SectionsContext';
import { SECTION_TYPES } from '../../../../constants';


export const UncategorizedSection = () => {
  const { t } = useTranslation(['events']);
  const {
    hasCustomSections,
    expandedSections,
    toggleSection,
    tiersBySection,
    children
  } = useSectionsContext();

  const defaultTiers = tiersBySection.default || [];

  return (
    <div className="w-full order-first md:order-last">
      <div
        className={classNames(
          'border-t-2 border-[#EBEBEB] -mx-4 md:mx-6 bg-white',
          {
            hidden: !hasCustomSections,
            block: hasCustomSections
          }
        )}
      />
      <div
        className={classNames(
          'md:px-6 pt-4 flex-col gap-3 bg-white rounded-lg',
          {
            hidden: !hasCustomSections,
            flex: hasCustomSections
          }
        )}
      >
        <button
          type="button"
          className="flex items-center justify-between cursor-pointer text-left w-full"
          onClick={() => toggleSection('default')}
        >
          <h3 className="text-lg font-semibold text-black">
            {t('events:pricingTiers.categories.uncategorized')}
            {defaultTiers.length > 0 && (
              <span> ({defaultTiers.length})</span>
            )}
          </h3>
          <IoChevronDown
            size={24}
            className={`ml-2 text-black transition-transform duration-200 ${
              expandedSections.default ? '' : 'transform rotate-180'
            }`}
          />
        </button>
        <p className="text-sm text-[#575757] pb-2">
          {t('events:pricingTiers.categories.uncategorizedDescription')}
        </p>
      </div>

      <Droppable droppableId="default" type={SECTION_TYPES.TIERS}>
        {(provided) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            className="mb-2 px-2 rounded-2xl"
          >
            {!expandedSections.default &&
              children(
                defaultTiers.sort((a, b) => a.sortIndex - b.sortIndex),
                'default'
              )}
            {provided.placeholder}
          </div>
        )}
      </Droppable>

      <div className="pb-4" />
      <div
        className={classNames(
          'border-b-2 border-[#EBEBEB] -mx-10 md:mx-2',
          {
            hidden: !hasCustomSections,
            'hidden md:block': hasCustomSections
          }
        )}
      />
    </div>
  );
}; 